import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation DocumentReportListPage_ArchiveDocumentReport(
    $documentReportId: ID!
  ) {
    changeDocumentStatus(documentId: $documentReportId, newStatus: archived) {
      ok
    }
  }
`)

export const useArchiveDocumentReportMutation = (
  options: MutationOptions<void, string> = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async (documentReportId) => {
      const result = await graphQLRequest({
        document,
        variables: { documentReportId },
      })
      const ok = result.changeDocumentStatus?.ok
      if (!ok) {
        throw new Error(t('archive_failed'))
      }
    },
    ...options,
  })
}
